<ng-container *ngFor="let filter of filters | keyvalue">
  <div *ngIf="shouldShow(filter)">
    <mat-icon inline="true" style="height:18px" (click)="delete(filter)">clear</mat-icon>
    <label>{{displayKey(filter)}}: </label>
    <span>{{displayText(filter)}}</span>
  </div>
</ng-container>
